import { Title } from "@circle-react-shared/Paywalls/PriceDisplay/Title";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { PaywallCustomization } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PaywallCustomization";
import { PriceContextProvider } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PriceSelector/PriceDescription/Price/PriceProvider";
import { PriceDisplay } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PriceSelector/PriceDescription/PriceDisplay";
import type { PaywallPriceToRenderCheckout } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PriceSelector/PriceDescription/types";
import type { CouponApplications, Paywall } from "@circle-react/types";

import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

interface PaywallDescriptionProps {
  couponApplications?: CouponApplications;
  paywall: Paywall;
  paywallDisplayName?: string;
  price: PaywallPriceToRenderCheckout;
}

export const PaywallDescription = ({
  paywall,
  paywallDisplayName,
  price,
  couponApplications,
}: PaywallDescriptionProps) => (
  <div
    className="flex flex-col py-4 gap-y-1 first:pt-0"
    data-testid="paywall_description"
  >
    <TippyV2 content={paywallDisplayName || paywall.display_name}>
      <span className="flex w-[70%]">
        <Typography.LabelMd weight="semibold" color="text-primary" truncate>
          {paywallDisplayName || paywall.display_name}
        </Typography.LabelMd>
      </span>
    </TippyV2>

    <div className="flex flex-row gap-x-4 justify-between">
      <div className="flex flex-col gap-y-0.5 w-full">
        <PriceContextProvider Title={Title.ConfirmationPage}>
          <PaywallCustomization.ReducedPrice.Offer
            price={price}
            couponApplications={couponApplications}
          >
            <PriceDisplay
              paywall={paywall}
              price={price}
              className="w-full"
              couponApplications={couponApplications}
            />
          </PaywallCustomization.ReducedPrice.Offer>
        </PriceContextProvider>
        <Typography.LabelXs color="text-secondary" weight="medium">
          {price.title}
        </Typography.LabelXs>
      </div>
      <PaywallCustomization.Detailed.Cover
        className="!w-[71px] !h-[41px]"
        mediaClassName="!rounded-[0.416rem]"
        overrideVideoProperties={{
          autoplay: false,
          muteVideo: true,
          loopVideo: false,
          shouldShowControls: false,
        }}
      />
    </div>
  </div>
);
